import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { BASE_URL } from '../keys';
export const googleAuthApi = createApi({
    reducerPath: 'googleAuthApi',
    baseQuery: fetchBaseQuery({
       baseUrl: BASE_URL,
        // baseUrl: 'https://hpsmithstagebe.six30labs.com/',                          // adjust to your API base URL
        prepareHeaders: (headers) => {
            const token = localStorage.getItem('access_token')
            if (token) headers.set('Authorization', `Bearer ${token}`)
            return headers
        },
    }),
    endpoints: (builder) => ({
        googleLogin: builder.mutation({
            query: (payload) => ({
                url: 'common/google-login/',
                method: 'POST',
                body: payload,
                // payload shape:
                // { google_token, email, first_name, last_name }
            }),
        }),
    }),
})

export const { useGoogleLoginMutation } = googleAuthApi